import { gql } from "@apollo/client";

export const upsertSiteCheckCallMutation = gql`
mutation($input: SiteCallCheckInput!){
  upsertSiteCheckCall(input: $input) {
    message
    response
  }
}
`;

export const AddNewBulkTaskintoCheckCallMutation = gql`
mutation($newTaskCheckCall: [newTaskCheckCallInput!]!){
  addNewBulkTaskintoCheckCall(newTaskCheckCall: $newTaskCheckCall) {
    message
    response
  }
}
`;

export const regenerateClockVerificationQrMutation = gql`
mutation($siteId: String!, $callType: String!){
  regenerateClockVerificationQr(siteId: $siteId, callType: $callType) {
    message
    response
  }
}
`;

export const assignClockVerificationNfcTagMutation = gql`
mutation($siteId: String!, $callType: String!, $nfcTagId: String!){
  assignClockVerificationNfcTag(siteId: $siteId, callType: $callType, nfcTagId: $nfcTagId) {
    message
    response
  }
}
`;

export const removeClockVerificationNfcTagMutation = gql`
mutation($siteId: String!, $callType: String!){
  removeClockVerificationNfcTag(siteId: $siteId, callType: $callType) {
    message
    response
  }
}
`;